import { api } from './base';

import { ProviderName } from 'v2/constants';
import { MutationArg, Pageable } from 'v2/types';
import { AnyFreeSpinInfoModel, FreeSpinModel, FreeSpinsFilter } from 'v2/types/FreeSpinModel';
import { ProviderSlotModel } from 'v2/types/SlotModel';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';

export const providerService = {
  getProviderGames([_key, providerName]: [string, ProviderName]): Promise<ProviderSlotModel[]> {
    return api.get(`v1/admin/provider-info/${providerName}/games`).json();
  },

  getProviderGameInfo(
    [_key, providerName]: [string, ProviderName],
    { arg: gameId }: MutationArg<string>
  ): Promise<AnyFreeSpinInfoModel> {
    return api.get(`v1/admin/provider-info/${providerName}/game/${gameId}`).json();
  },

  getFreeSpins([_key, page, limit, filter]: SWRKeyPaginationWithExtra<FreeSpinsFilter>): Promise<
    Pageable<FreeSpinModel>
  > {
    return api
      .get('v1/admin/provider-free-spins', {
        searchParams: {
          page,
          limit,
          filter: JSON.stringify(filter),
          sortFields: JSON.stringify({ createdAt: 'desc' }),
        },
      })
      .json();
  },

  createFreeSpins(_key: string, { arg }: MutationArg<Omit<FreeSpinModel, 'id' | 'createdAt'>>): Promise<FreeSpinModel> {
    return api.post('v1/admin/provider-free-spins', { json: arg }).json();
  },

  deleteFreeSpins([_key, freeSpinsId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/provider-free-spins/${freeSpinsId}`).json();
  },
};
